<template>
  <div>
    <div class="zjz_con">
      <div class="zjz_l">
        <div style="display: flex">
          <div class="title">
            <img :src="$_c + 'img/jjz_img/btn_bg.svg'" />
            <span>包组栏</span>
          </div>
          <div class="zjz_l_c">
            <div>
              <div>
                {{ packs.title }}：{{ packs.packName }}
                <a-button
                  type="link"
                  icon="search"
                  size="small"
                  @click="onSubject"
                  style="color: #fffe00"
                >
                  查看标的物
                </a-button>
              </div>
              <div>包组编号：{{ packs.packCode }}</div>
            </div>
          </div>
          <div class="title">
            <img :src="$_c + 'img/jjz_img/btn_bg.svg'" />
            <span>报价栏</span>
          </div>
        </div>
        <div>
          <a-tabs
            v-model="selectPackIndex"
            :tabBarStyle="{ border: 'unset' }"
            tabPosition="left"
            @change="selectPack"
          >
            <a-tab-pane v-for="(item, index) in packsList" :key="index">
              <template slot="tab">
                <a-tooltip placement="top">
                  <template slot="title">
                    <span>{{ item.packName }}</span>
                  </template>
                  <span style="font-weight: bold">{{ item.title }}&nbsp;</span>
                  <span>{{ item.packName }}</span>
                </a-tooltip>
              </template>
              <div v-if="packs.jingjiaWay == '1'">
                <NewFreedomCompete
                  ref="jingjia"
                  :packId="item.id"
                  :selectPackIndex="index + 1"
                ></NewFreedomCompete>
              </div>
              <div v-if="packs.jingjiaWay == '2'">
                <NewSingleCompete
                  ref="jingjia"
                  :packId="item.id"
                  :selectPackIndex="index + 1"
                ></NewSingleCompete>
              </div>
            </a-tab-pane>
          </a-tabs>
        </div>
      </div>
      <BidSubject ref="sbt" :visible="bidSubjectVisible" @cancel="cancel"></BidSubject>
      <!--抽签环节的抽屉 -->
      <!-- <CompetitiveResultDrawV2 ref="draw"></CompetitiveResultDrawV2> -->
      <!-- <div class="draw_btn">
        <a-button type="primary" icon="align-left" @click="openDraw" />
      </div> -->
    </div>
  </div>
</template>

<script>
import NewFreedomCompete from "./NewFreedomCompete";
import NewSingleCompete from "./NewSingleCompete";
import BidSubject from "../product/BidSubject";
// import CompetitiveResultDrawV2 from "./CompetitiveResultDrawV2";
import { Icon } from "ant-design-vue";
export default {
  name: "newSingleCompete",
  data() {
    return {
      projectId: this.$route.query.projectId,
      code: this.$route.query.code, //竞价是否进行中
      packs: {},
      packId: "",
      packsList: [],
      selectPackIndex: 0,
      bidSubjectVisible: false,
      // webSoocketUrl:"ws://localhost:8010/bidding/1/2"
    };
  },
  components: {
    NewFreedomCompete,
    NewSingleCompete,
    BidSubject,
    // CompetitiveResultDrawV2,
  },
  created() {
    if(this.websock){
      this.websock.close();
    }
    this.$ls.remove(this.$route.query.projectId)
    this.$ls.remove("packLength")
    this.getPacks();
  },
  beforeDestroy() {
    this.websock.close();
    this.$ls.remove("packLength")
  },
  methods: {
    selectPack(index) {
      this.packId = this.packsList[index].id;
      this.packs = this.packsList[index];
      this.selectPackIndex = index;
    },
    getPacks() {
      let that = this;
      this.$http
        .get("/api/v1/supplier/packs/getSignedPacks.json?projectId=" + this.projectId)
        .then(function (res) {
          let packsId = res.result.list[0].id;
          that.packsList = res.result.list;
          that.$ls.set("packLength", that.packsList.length)
          that.packId = packsId;
          that.packs = res.result.list[0];
          that.initWebSocket();
          for (let i = 0; i < that.packsList.length; i++) {
            that.packsList[i].title = that.packsList[i].extras.packName;
          }
        });
    },
    openDraw() {
      this.$refs.draw.modalVisible = true;
    },
    cancel() {
      this.bidSubjectVisible = false;
    },
    onSubject() {
      this.bidSubjectVisible = true;
      this.$refs.sbt.initData(this.packId);
    },
    initWebSocket: function () {
      if (typeof WebSocket == "undefined") {
        console.log("您的浏览器不支持WebSocket");
      } else if (this.code == 1 || this.code == 2) {
        this.websock = new WebSocket(
          "wss://" +
            process.env.VUE_APP_API_SERVER.split("//")[1] +
            "/webSocket/bidding/" +
            this.projectId +
            "/" +
            this.$ls.get("user").supplierId
        );
        this.websock.onopen = this.websocketonopen;
        this.websock.onerror = this.websocketonerror;
        this.websock.onmessage = this.websocketonmessage;
        this.websock.onclose = this.websocketclose;
      }
    },
    sendMessage() {
      this.websock.send(this.text);
    },
    websocketonopen() {
      console.log("WebSocket连接成功");
    },
    websocketonerror(e) {
      console.log("WebSocket连接发生错误");
    },
    websocketonmessage(e) {
      // this.msg_data.push(e.data);
      console.log(e);
    },
    websocketclose(e) {
      console.log("connection closed (" + e.code + ")");
    },
  },
};
</script>
<style lang="less" scoped>
.draw_btn {
  position: absolute;
  text-align: center;
  height: 50px !important;
  top: 0.5vw;
  left: 1vw;
  .ant-btn {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
/deep/ .ant-tabs-tab {
  width: 19.531vw;
  text-align: left !important;
  font-size: 0.9vw;
  color: #ffffff;
  text-shadow: 0 0.156vw 0 rgba(0, 0, 0, 0.2784);
  background: linear-gradient(90deg, #18336a 0%, rgba(24, 51, 106, 0) 100%);
}
/deep/ .ant-tabs-tab-active {
  background: linear-gradient(90deg, #0084ff 0%, rgba(0, 132, 255, 0) 100%);
}
/deep/ .ant-tabs .ant-tabs-left-content {
  border: unset;
  background: #18336a;
  width: 80.469vw;
  padding: 0 0 0 0.625vw;
}
.zjz_con {
  height: 100vh;
  display: flex;
  overflow: hidden;

  > div {
    height: 100%;
  }

  .zjz_l {
    width: 100%;
    background: #132957;
    box-shadow: inset -5px 0px 10px 1px rgba(0, 0, 0, 0.2784);
    .title {
      width: 19.531vw;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .zjz_l_c {
      display: flex;
      justify-content: center;
      align-items: center;
      background: #18336a;
      width: 61.3vw;
      padding: 0.625vw;
      > div {
        width: 100%;
        padding: 0 0.521vw;
        color: white;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #1d315a;
        border: 0.052vw solid #3c5583;
        font-size: 0.729vw;
      }
    }
  }

  .zjz_c {
    background: #18336a;
    width: 100%;
    padding: 0.625vw;
    box-sizing: border-box;
    /* 中间的包组信息样式 */
    /deep/ .ant-btn-sm {
      height: 1.25vw;
      padding: 0 0.365vw;
      font-size: 0.729vw;
      border-radius: 0.208vw;
    }

    .t2 {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      font-size: 1.667vw;

      .box {
        width: 3.229vw;
        height: 2.813vw;
        line-height: 2.813vw;
        text-align: center;
        background: #ebebeb;
        border-radius: 0.208vw;
        color: #000;
        font-size: 1.979vw;
        font-weight: bold;
        box-shadow: inset 0 -1.563vw 0 0 #c8c8c8;
        margin: 0 0.417vw;
      }
    }

    /deep/ .t3 {
      margin-bottom: 0.938vw;

      .ant-progress-inner {
        border-radius: 0;
        overflow: inherit;
      }

      .ant-progress-bg {
        border-radius: 0 !important;
        height: 1.042vw !important;
      }

      .arrow {
        width: 100%;
        max-width: 40.625vw;
        margin: auto;

        .ant-progress-inner {
          background: #e9c376;
        }
      }

      .arrow .ant-progress-bg::before {
        content: "";
        border-top: 0.521vw solid rgba(0, 0, 0, 0);
        border-right: 0.521vw solid rgba(0, 0, 0, 0);
        border-bottom: 0.521vw solid #e9c376;
        border-left: 0.521vw solid rgba(0, 0, 0, 0);
        position: absolute;
        right: -0.521vw;
        top: 0.521vw;
      }

      .arrow.red .ant-progress-inner {
        background: #e97a76;
      }
      .countDown {
        position: absolute;
        right: 29.6vw;
      }
      .countDown.red .ant-progress-inner {
        background: #e97a76;
      }
      .countDown.red .ant-progress-bg::before {
        content: "";
        border-top: 0.521vw solid rgba(0, 0, 0, 0);
        border-right: 0.521vw solid rgba(0, 0, 0, 0);
        border-bottom: 0.521vw solid #e97a76;
        border-left: 0.521vw solid rgba(0, 0, 0, 0);
        position: absolute;
        right: -0.521vw;
        top: 0.521vw;
      }
      .arrow.red .ant-progress-bg::before {
        content: "";
        border-top: 0.521vw solid rgba(0, 0, 0, 0);
        border-right: 0.521vw solid rgba(0, 0, 0, 0);
        border-bottom: 0.521vw solid #e97a76;
        border-left: 0.521vw solid rgba(0, 0, 0, 0);
        position: absolute;
        right: -0.521vw;
        top: 0.521vw;
      }
    }
  }
}

/deep/ .ant-btn {
  height: 2vw;
  padding: 0 0.781vw;
  font-size: 0.729vw;
  line-height: 2vw;
  border: none;
}

.Operation_area {
  color: #fff;
  .t1 {
    text-align: center;
  }
  .t2 {
    margin-top: 0.625vw;
    display: flex;
    align-items: center;
    /deep/ .ant-input-number {
      width: 100%;
      border: 0.052vw solid #5e6a84;
      height: 3.646vw;
    }
    /deep/ .ant-input-number-input-wrap {
      height: 100%;
      .ant-input-number-input {
        font-size: 2.083vw;
        text-align: center;
        color: #ff0000;
        background: #0b1d41;
        height: 100%;
      }
    }
    .btn {
      padding: 0 0.625vw;
      flex: 0 0 auto;
      font-weight: bold;
      i {
        font-size: 2.083vw;
      }
    }
  }
  .t3 {
    margin: 0.625vw 0 0 0;
    display: flex;
    padding: 0 2vw;
    .ant-btn {
      flex: 1;
      padding: 0;
    }
  }
}

.ant-divider-horizontal {
  margin: 1.25vw 0;
}

.title {
  position: relative;
  text-align: center;

  img {
    display: block;
    margin: auto;
    width: 10vw;
  }

  span {
    position: absolute;
    left: 0;
    right: 0;
    text-align: center;
    top: 0.9vw;
    color: #fff;
    font-size: 0.9vw;
    font-weight: bold;
  }
}

.back-list {
  margin: 0;
  padding: 0.625vw;

  div {
    padding: 0 0.625vw;
    margin-bottom: 0.417vw;
    min-height: 2.604vw;
    display: flex;
    align-items: center;
    background: linear-gradient(90deg, #18336a 0%, rgba(24, 51, 106, 0) 100%);

    &.pack-title-active {
      background: linear-gradient(90deg, #0084ff 0%, rgba(0, 132, 255, 0) 100%);
    }

    &.pack-title {
      cursor: pointer;
    }

    span {
      font-size: 0.938vw;
      color: #ffffff;
      font-weight: bold;
      text-shadow: 0 0.156vw 0 rgba(0, 0, 0, 0.2784);
    }
  }
}

.flex-left {
  padding: 0 10px;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

/* 我的竞价编号 */
.code {
  color: white;
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
}

.scrollbar-zdy {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 100%;
  margin-right: -4px;
}

/*-------滚动条整体样式----*/
.scrollbar-zdy::-webkit-scrollbar {
  width: 4px;
}

/*滚动条里面小方块样式*/
.scrollbar-zdy::-webkit-scrollbar-thumb {
  border-radius: 100px;
  background: rgba(0, 0, 0, 0.2);
}

/*滚动条里面轨道样式*/
.scrollbar-zdy::-webkit-scrollbar-track {
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}
</style>
